import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiScissors,FiAward,FiUsers,FiClock}=FiIcons;

function About() {
  const stats=[
    {icon: FiUsers,number: '1000+',label: 'Happy Customers'},
    {icon: FiScissors,number: '15+',label: 'Years Experience'},
    {icon: FiAward,number: '50+',label: 'Awards Won'},
    {icon: FiClock,number: '24/7',label: 'Customer Support'}
  ];

  const teamMembers=[
    {name: 'Michael Johnson',position: 'Master Barber',experience: '15 years',image: 'https://i.ibb.co/C3rPYRRz/images-8.jpg',description: 'Specializes in classic cuts and traditional shaving techniques.'},
    {name: 'David Smith',position: 'Senior Barber',experience: '12 years',image: 'https://i.ibb.co/ksBb7LJd/images-9.jpg',description: 'Expert in modern styling and beard grooming.'},
    {name: 'Robert Brown',position: 'Barber Stylist',experience: '8 years',image: 'https://i.ibb.co/8nyj4b12/images-10.jpg',description: 'Creative stylist known for trendy cuts and attention to detail.'}
  ];

  return (
    <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} transition={{duration: 0.5}} className="flex-1" >
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-black via-gray-900 to-black py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h1 initial={{y: 50,opacity: 0}} animate={{y: 0,opacity: 1}} transition={{delay: 0.2,duration: 0.8}} className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6" >
            About <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-600">Us</span>
          </motion.h1>
          <motion.p initial={{y: 50,opacity: 0}} animate={{y: 0,opacity: 1}} transition={{delay: 0.4,duration: 0.8}} className="text-xl text-gray-400 max-w-2xl mx-auto" >
            Discover the story behind West End Barbers and our commitment to excellence
          </motion.p>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-20 bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <motion.div initial={{x: -50,opacity: 0}} whileInView={{x: 0,opacity: 1}} transition={{duration: 0.8}} viewport={{once: true}} >
              <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
                Our Story
              </h2>
              <p className="text-gray-400 text-lg leading-relaxed mb-6">
                West End Barbers has been serving the Toronto community for over 15 years,combining traditional barbering techniques with modern style. Our passion for the craft and dedication to customer satisfaction has made us a trusted name in men's grooming.
              </p>
              <p className="text-gray-400 text-lg leading-relaxed mb-6">
                Located in the vibrant west end of Toronto,we've built our reputation on quality service,attention to detail,and creating an atmosphere where every customer feels valued and comfortable.
              </p>
              <p className="text-gray-400 text-lg leading-relaxed">
                Our team of skilled barbers brings years of experience and a commitment to excellence that shows in every cut,every shave,and every satisfied customer who walks out our door.
              </p>
            </motion.div>
            
            <motion.div initial={{x: 50,opacity: 0}} whileInView={{x: 0,opacity: 1}} transition={{duration: 0.8}} viewport={{once: true}} className="grid grid-cols-2 gap-4" >
              <img src="https://i.ibb.co/vCmDP3wK/images-11.jpg" alt="Barber shop interior" className="w-full h-48 object-cover rounded-lg border border-yellow-500/20" />
              <img src="https://i.ibb.co/4Zp6QVYt/images-12.jpg" alt="Barber tools" className="w-full h-48 object-cover rounded-lg border border-yellow-500/20 mt-8" />
              <img src="https://i.ibb.co/cXxmxhgM/images-13.jpg" alt="Barber at work" className="w-full h-48 object-cover rounded-lg border border-yellow-500/20 -mt-8" />
              <img src="https://i.ibb.co/sd3gSpHG/images-14.jpg" alt="Happy customer" className="w-full h-48 object-cover rounded-lg border border-yellow-500/20" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div initial={{y: 50,opacity: 0}} whileInView={{y: 0,opacity: 1}} transition={{duration: 0.8}} viewport={{once: true}} className="text-center mb-16" >
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">Our Achievements</h2>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto">Numbers that speak to our commitment and success</p>
          </motion.div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {stats.map((stat,index)=> (
              <motion.div key={index} initial={{y: 50,opacity: 0}} whileInView={{y: 0,opacity: 1}} transition={{delay: index * 0.2,duration: 0.8}} viewport={{once: true}} className="text-center" >
                <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <SafeIcon icon={stat.icon} className="h-8 w-8 text-black" />
                </div>
                <h3 className="text-3xl font-bold text-yellow-400 mb-2">{stat.number}</h3>
                <p className="text-gray-400">{stat.label}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20 bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div initial={{y: 50,opacity: 0}} whileInView={{y: 0,opacity: 1}} transition={{duration: 0.8}} viewport={{once: true}} className="text-center mb-16" >
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">Meet Our Team</h2>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto">Skilled professionals dedicated to delivering exceptional service</p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {teamMembers.map((member,index)=> (
              <motion.div key={index} initial={{y: 50,opacity: 0}} whileInView={{y: 0,opacity: 1}} transition={{delay: index * 0.2,duration: 0.8}} viewport={{once: true}} className="bg-black rounded-lg overflow-hidden border border-yellow-500/20 hover:border-yellow-500/50 transition-all duration-300 hover:transform hover:scale-105" >
                <div className="relative h-64 overflow-hidden">
                  <img src={member.image} alt={member.name} className="w-full h-full object-cover" />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-white mb-2">{member.name}</h3>
                  <p className="text-yellow-400 font-semibold mb-2">{member.position}</p>
                  <p className="text-gray-400 text-sm mb-3">{member.experience} of experience</p>
                  <p className="text-gray-400 text-sm leading-relaxed">{member.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-black">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h2 initial={{y: 50,opacity: 0}} whileInView={{y: 0,opacity: 1}} transition={{duration: 0.8}} viewport={{once: true}} className="text-3xl sm:text-4xl font-bold text-white mb-6" >
            Our Values
          </motion.h2>
          <motion.p initial={{y: 50,opacity: 0}} whileInView={{y: 0,opacity: 1}} transition={{delay: 0.2,duration: 0.8}} viewport={{once: true}} className="text-xl text-gray-400 leading-relaxed mb-8" >
            At West End Barbers,we believe in excellence,integrity,and building lasting relationships with our customers. Every service we provide is backed by our commitment to quality and our passion for the craft of barbering.
          </motion.p>
          <motion.a initial={{y: 50,opacity: 0}} whileInView={{y: 0,opacity: 1}} transition={{delay: 0.4,duration: 0.8}} viewport={{once: true}} href="tel:+14166379929" className="inline-block bg-gradient-to-r from-yellow-400 to-yellow-600 text-black px-8 py-3 rounded-lg font-semibold hover:shadow-lg transform hover:scale-105 transition-all duration-300" >
            Experience the Difference
          </motion.a>
        </div>
      </section>
    </motion.div>
  );
}

export default About;